import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Message from './message';
import { withTranslation } from "react-i18next";

class Messages extends Component {
    
    render() {
        return (
            <div className="meesages-list-hist position-relative top-0 start-0">
                {
                    this.props.interaction.messages.map((m, i) => {

                        let user = JSON.parse(localStorage.getItem("fc-logged")),
                            type = m.type,
                            image = this.props.interaction.image,
                            senderName = type === "A" ? this.props.agentName : this.props.interaction.name,
                            ref = createRef(),
                            // * loading more messages should not change the current messages ids.
                            mesgId = this.props.interaction.messages.length - i;

                        if ((m.text != null && m.text.length > 0) || m.media)
                            this.props.addMessageRef(ref);

                        if (m.isHistory && type === "A") {
                            image = m.image;
                            senderName = m.userName;
                        }

                        if (this.props.interaction.channel === "internal") {
                            type = m.from === user.userId ? "A" : "U";
                        }
                        
                        return (<Message
                            childref={ref}
                            key={`m_${mesgId}`}
                            id={`m_${mesgId}`}
                            senderName={senderName}
                            text={m.text}
                            buttonText={m.buttonText}
                            type={type}
                            channel={this.props.interaction.channel}
                            media={m.media}
                            image={image}
                            mediaType={m.mediaType}
                            url={m.url}
                            from={m.from}
                            isHistory={m.isHistory}
                            date={m.date}
                            reference={m.reference}
                            contacts={m.contacts}
                            ogText={m.ogText}
                        />)
                    })
                }
                <div ref={this.props.lastMessage} >
                </div>
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
    };
};
export default compose(connect(mapStateToProps), withTranslation())(Messages);